import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=96540120&scoped=true&"
import script from "./HelpIcon.vue?vue&type=script&lang=js&"
export * from "./HelpIcon.vue?vue&type=script&lang=js&"
import style0 from "./HelpIcon.vue?vue&type=style&index=0&id=96540120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96540120",
  null
  
)

export default component.exports